import React from "react";

import ScopeSummaryBox from "./workScopeSummary/ScopeSummaryBox";
import NoScopesBox from "./workScopeSummary/NoScopesBox";

/**
 * Component that displays a summary of work scopes and assigned workers for a given job on a specific day.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.scopes - The list of work scopes for the day.
 * @param {Object} props.job - The job object containing job details.
 * @param {{ id: number, colorHex: string }|null} [props.hoveredBlock] - Hovered Schedule-block link shared across the job row.
 * @param {Function} [props.onBlockHover] - Setter for the hovered Schedule-block link.
 * @returns {JSX.Element} The rendered component.
 */
const WorkScopesSummary = ({
  scopes,
  job,
  hoveredBlock = null,
  onBlockHover = null,
}) => {
  // How many scopes today match the Job ID and therefore should be in this section
  const numOfScopes = scopes
    ? scopes.filter((scope) => scope.job.id === job.id).length
    : 0;

  return (
    <div>
      {numOfScopes > 0 ? (
        <>
          {scopes.map((scope) => (
            <ScopeSummaryBox
              key={scope.id}
              scope={scope}
              job={job}
              hoveredBlock={hoveredBlock}
              onBlockHover={onBlockHover}
            />
          ))}
        </>
      ) : (
        <NoScopesBox />
      )}
    </div>
  );
};

export default WorkScopesSummary;
